'use strict';

export default {
  // List of user roles
  userRoles: ['user', 'admin']
};
